var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66602 6.80004C2.66602 3.79871 5.03625 1.33337 7.99935 1.33337C10.9625 1.33337 13.3327 3.79871 13.3327 6.80004C13.3327 8.33104 12.6566 9.67125 11.7413 10.8937C10.9774 11.914 9.99948 12.9111 9.0267 13.903C8.84291 14.0904 8.6593 14.2776 8.47735 14.4648C8.35182 14.5939 8.17942 14.6667 7.99935 14.6667C7.81928 14.6667 7.64687 14.5939 7.52135 14.4648C7.3394 14.2776 7.15579 14.0904 6.972 13.903C5.99922 12.9111 5.02131 11.914 4.25736 10.8937C3.34206 9.67125 2.66602 8.33104 2.66602 6.80004ZM7.99935 2.66671C5.80779 2.66671 3.99935 4.49944 3.99935 6.80004C3.99935 7.91998 4.48997 8.97976 5.32467 10.0946C6.03045 11.0372 6.93373 11.9588 7.90766 12.9525C7.93815 12.9836 7.96872 13.0148 7.99935 13.046C8.02998 13.0148 8.06055 12.9836 8.09104 12.9525C9.06497 11.9588 9.96825 11.0372 10.674 10.0946C11.5087 8.97976 11.9993 7.91998 11.9993 6.80004C11.9993 4.49943 10.1909 2.66671 7.99935 2.66671Z",
    fill: "#1E4161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.66663C6 5.56206 6.8954 4.66663 8 4.66663C9.1046 4.66663 10 5.56206 10 6.66663C10 7.77122 9.10459 8.66663 8 8.66663C6.89541 8.66663 6 7.77122 6 6.66663ZM8 5.99996C7.6318 5.99996 7.33333 6.29843 7.33333 6.66663C7.33333 7.03484 7.63179 7.33329 8 7.33329C8.36821 7.33329 8.66667 7.03484 8.66667 6.66663C8.66667 6.29843 8.3682 5.99996 8 5.99996Z",
    fill: "#1E4161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0c94c0a61f3f3e88a7fa2625382261f1.svg";
export { ForwardRef as ReactComponent };